import { Loop54Product } from '~/services/loop54/types';
import { useTranslations } from '~/services/umbraco/hooks';
import { ProductCard } from '../ProductCard';
import { Grid } from './styled';
import { useMemo } from 'react';

interface Props {
    items: Loop54Product[] | undefined;
    itemListName?: string;
    isFullWidth?: boolean;
}

export default function ProductList({ items, itemListName, isFullWidth = false }: Props) {
    const { translate } = useTranslations();

    const productsWithPrices = useMemo(
        () =>
            items?.map((item) => {
                return {
                    key: item.Id,
                    product: item,
                };
            }),
        [items],
    );

    return (
        <Grid isFullWidth={isFullWidth}>
            {productsWithPrices?.map((product) => (
                <ProductCard
                    key={product.product.Id}
                    product={product.product}
                    translate={translate}
                    itemListName={itemListName}
                />
            ))}
        </Grid>
    );
}

function ProductListSkeleton({ isFullWidth = false }) {
    return (
        <Grid isFullWidth={isFullWidth}>
            {Array.from({ length: 10 }).map((_, index) => (
                <ProductCard.Skeleton key={index} />
            ))}
        </Grid>
    );
}

ProductList.Skeleton = ProductListSkeleton;
